let pageMixin
let asyncData

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  pageMixin = {
    computed: {
      itemtitle() {
        return this.item.name
      },
      links() {
        let pagetitle = (this.title) || this.item.name
        let pageurl = (this.pageurl) || this.$route.path
        return {
          'facebook': {
            'url': 'https://www.facebook.com/sharer/sharer.php?u=' + pageurl + '&title=' + pagetitle + '&description=' + this.description,
            'title': 'Facebook',
            'shareContext': 'Share on',
            'icon': 'facebook'
          },
          'twitter': {
            'url': 'https://twitter.com/intent/tweet?text=' + pagetitle + '&url=' + pageurl,
            'title': 'Twitter',
            'shareContext': 'Share on',
            'icon': 'twitter'
          },
          'linkedin': {
            'url': 'https://www.linkedin.com/shareArticle?mini=true&url=' + pageurl + '&title=' + pagetitle + '&summary=' + this.description,
            'title': 'LinkedIn',
            'shareContext': 'Share on',
            'icon': 'linkedin'
          },
          'email': {
            'url': 'mailto:?subject=' + pagetitle + '&body=' + this.description + '%0D%0A %0D%0A Checkout the link at: ' + pageurl,
            'title': 'Email',
            'shareContext': 'Share by',
            'icon': 'email'
          }
        }
      },
      contentType() {
        return 'Page'
      // return this.$store.getters['config/contentTypeName'](this.node.type)
      }
    }
  }
}
else {
  pageMixin = {
    computed: {
      itemtitle() {
        return this.item.title
      },
      pageUrl() {
        if (typeof window !== 'undefined') {
          return window.location.href
        }
        return ''
      },
      pageTitle() {
        return this.pagetitle || this.item.title
      },
      links() {
        return {
          'facebook': {
            'url': 'https://www.facebook.com/sharer/sharer.php?u=' + this.pageUrl + '&title=' + this.pageTitle + '&description=' + this.description,
            'title': 'Facebook',
            'shareContext': 'Share on',
            'icon': 'facebook'
          },
          'twitter': {
            'url': 'https://twitter.com/intent/tweet?text=' + this.pageTitle + '&url=' + this.pageUrl,
            'title': 'Twitter',
            'shareContext': 'Share on',
            'icon': 'twitter'
          },
          'linkedin': {
            'url': 'https://www.linkedin.com/shareArticle?mini=true&url=' + this.pageUrl + '&title=' + this.pageTitle + '&summary=' + this.description,
            'title': 'LinkedIn',
            'shareContext': 'Share on',
            'icon': 'linkedin'
          },
          'email': {
            'url': 'mailto:?subject=' + this.pageTitle + '&body=' + this.description + '%0D%0A %0D%0A Checkout the link at: ' + this.pageUrl,
            'title': 'Email',
            'shareContext': 'Share by',
            'icon': 'email'
          }
        }
      },
      contentType() {
        return 'Page'
      // return this.$store.getters['config/contentTypeName'](this.node.type)
      }
    }
  }
}

export default pageMixin
export {
  asyncData,
  pageMixin
}
